// extracted by mini-css-extract-plugin
export var indeterminate = "_45-6";
export var md = "_45-5";
export var semantic = "_45-7";
export var sm = "_45-4";
export var text = "_45-8";
export var toggleControl = "_45-0";
export var toggleInput = "_45-1";
export var toggleSwitch = "_45-2";
export var xs = "_45-3";